import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./index.css";
import axios from "axios";

function SharedDynamicForm() {
  const { id: formId } = useParams();
  const [savedFields, setSavedFields] = useState([]);
  const [formData, setFormData] = useState({});
  const [parentForm, setParentForm] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [submitButton, setSubmitButton] = useState({ text: "Submit", color: "#007bff", textColor: "#ffffff" });

  useEffect(() => {
    const fetchFields = async () => {
      try {
        const res = await fetch(`https://leadbankapi.gensparc.com/api/submissions/${formId}`);
        if (!res.ok) throw new Error("Form fields not found");
        const data = await res.json();
        data.sort((a, b) => a.position - b.position);
        setSavedFields(data);
      } catch (err) {
        console.error(err);
      }
    };

    const fetchParentForm = async () => {
      try {
        const res = await fetch(`https://leadbankapi.gensparc.com/api/submissions/share/${formId}`);
        if (!res.ok) throw new Error("Parent form not found");
        const data = await res.json();
        setParentForm(data);
      } catch (err) {
        console.error(err);
      }
    };

    const fetchSubmitButton = async () => {
      try {
        const res = await fetch(`https://leadbankapi.gensparc.com/api/fields/${formId}/submit-button`);
        if (!res.ok) throw new Error("Submit button settings not found");
        const data = await res.json();
        setSubmitButton({
          text: data.text || "Submit",
          color: data.color || "#007bff",
          textColor: data.textColor || "#ffffff",
        });
      } catch (err) {
        console.error(err);
      }
    };

    fetchFields();
    fetchParentForm();
    fetchSubmitButton();
  }, [formId]);

 const handleChange = (label, value) => {
    setFormData((prev) => ({ ...prev, [label]: value }));
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://leadbankapi.gensparc.com/api/submissions", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          form_id: formId,
          submission_data: formData,
        }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to save submission");
      }
      setSubmitted(true);
      await sendToDialer();

    } catch (error) {
      console.error("Error submitting form:", error);
      alert(error.message);
    }
  };

  if (submitted) {
    return (
      <div className="app-container">
        <h1>Thank You!</h1>
        <p>Your submission has been received.</p>
      </div>
    );
  }

  // Send data to dialer
  const sendToDialer = async () => {
    try {
        const response = await fetch(`https://leadbankapi.gensparc.com/api/send-to-dialer/${formId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            }
        });

        const data = await response.json();
    } catch (error) {
        console.error("Error:", error);
        alert("An error occurred while sending leads.");
    }
};



  return (
    <div className="app-container">
      {/* Display Parent Form Details (including company image) */}
      {parentForm && (
        <div className="parent-form-details">
          <h1>{parentForm.company_name}</h1>
          {parentForm.company_image ? (
            <img
              src={`https://leadbankapi.gensparc.com${parentForm.company_image}`}
              alt="Company"
              className="company-image"
            />
          ) : (
            <p></p>
          )}
        </div>
      )}

      <form onSubmit={handleSubmit} className="shared-form">
        {/* If any custom field of type image exists, they can be rendered here */}
        {savedFields.some((field) => field.field_type === "image") && (
          <div className="shared-form-group image-preview">
            {savedFields.map((field, index) =>
              field.field_type === "image" && field.image_url ? (
                <img
                  key={index}
                  src={`https://leadbankapi.gensparc.com${field.image_url}`}
                  alt="Uploaded"
                  className="uploaded-image"
                />
              ) : null
            )}
          </div>
        )}

        {/* Render other custom fields */}
        {savedFields.map((field, index) => (
  <div key={index} className="shared-form-group">
    <label className="shared-form-label">
      {field.label} {Number(field.required) ? <span className="required-asterisk">*</span> : ""}
    </label>
    {field.field_type === "dropdown" ? (
      <select
        required={field.required}
        value={formData[field.label] || ""}
        onChange={(e) => handleChange(field.label, e.target.value)}
      >
        <option value="">Select an option</option>
        {JSON.parse(field.options).map((opt, i) => (
          <option key={i} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    ) : (
      <input
        type={field.field_type}
        required={field.required}
        value={formData[field.label] || ""}
        onChange={(e) => handleChange(field.label, e.target.value)}
      />
    )}
  </div>
))}


        {/* Customizable Submit Button */}
        <button
          type="submit"
          className="btn submit-btn"
          style={{ backgroundColor: submitButton.color, color: submitButton.textColor }}
        >
          {submitButton.text}
        </button>
      </form>

      {/* Policy Section at Bottom */}
      {parentForm?.policy_text && parentForm?.policy_link && (
        <div className="policy-section">
          <p>
            <a
              href={parentForm.policy_link}
              target="_blank"
              rel="noopener noreferrer"
              className="policy-link"
            >
              {parentForm.policy_text}
            </a>
          </p>
        </div>
      )}
    </div>
  );
}

export default SharedDynamicForm;

